import { Checkbox, CheckboxChangeEvent } from 'antd'
import { FC, useContext } from 'react'
import { FormValuesSingle } from '../../../../../../helpers/tables/get-data-for-update'
import CalculationPosition from '../../../../../../types/api/calculation-position'
import { CalculationPageCtx } from '../../../../calculations-page'

interface WithoutCuttingProps {
    checked?: boolean
    record: CalculationPosition
}

const WithoutCutting: FC<WithoutCuttingProps> = ({ checked, record }) => {
    const { onUpdateCalculationPositionProperty } = useContext(CalculationPageCtx)

    const handleChange = (e: CheckboxChangeEvent) => {
        const checked = e.target.checked

        if (checked) {
            const list: FormValuesSingle[] = [['withoutCutting', true]]

            if (record.stamp?.documentId) {
                list.push(['stamp', { disconnect: [record.stamp.documentId] }])
            }

            onUpdateCalculationPositionProperty(record, { list })
            return
        }

        onUpdateCalculationPositionProperty(record, ['withoutCutting', false])
    }

    return <Checkbox checked={checked} onChange={handleChange} />
}

export default WithoutCutting